module.exports = __webpack_public_path__ + "img/askPriceDesc3.adf74a16.png";